const PddStepOne = () => import('@/views/purchaseProcess/commonMode/pdd/stepOne')
const PddStepTwo = () => import('@/views/purchaseProcess/commonMode/pdd/stepTwo')
const PddStepThree = () => import('@/views/purchaseProcess/commonMode/pdd/stepThree')
const PddQuestionOne = () => import('@/views/purchaseProcess/commonMode/pdd/quesAndAnswers/QuestionOne')
const PddQuestionTwo = () => import('@/views/purchaseProcess/commonMode/pdd/quesAndAnswers/QuestionTwo')
const PddQuestionThree = () => import('@/views/purchaseProcess/commonMode/pdd/quesAndAnswers/QuestionThree')
const PddBaseStepOne = () => import('@/views/purchaseProcess/baseSaleMode/pdd/PddBaseStepOne')
const PddBaseStepTwo = () => import('@/views/purchaseProcess/baseSaleMode/pdd/PddBaseStepTwo')

export default [
  {
    name: 'pddStepOne',
    path: '/pddStepOne',
    component: PddStepOne,
    meta: {
      title: '第一步'
    }
  },
  {
    name: 'pddStepTwo',
    path: '/pddStepTwo',
    component: PddStepTwo,
    meta: {
      title: '第二步'
    }
  },
  {
    name: 'pddStepThree',
    path: '/pddStepThree',
    component: PddStepThree,
    meta: {
      title: '第三步'
    }
  },
  // 拼多多问题回答
  {
    name: 'pddQuestionOne',
    path: '/pddQuestionOne',
    component: PddQuestionOne
  },
  {
    name: 'pddQuestionTwo',
    path: '/pddQuestionTwo',
    component: PddQuestionTwo
  },
  {
    name: 'pddQuestionThree',
    path: '/pddQuestionThree',
    component: PddQuestionThree
  },
  // 基础销量模式第一步
  {
    name: 'pddBaseStepOne',
    path: '/pddBaseStepOne',
    component: PddBaseStepOne
  },
  {
    name: 'pddBaseStepTwo',
    path: '/pddBaseStepTwo',
    component: PddBaseStepTwo
  }
]
